module.exports = __webpack_public_path__ + "img/icn-army.9d366818.png";